export default "__VITE_ASSET__CKGfMRPE__"